import axios from "axios"
import store from "@/store"
import i18n from "@/locale/index"
import { Message } from "element-ui"
import { getToken } from "@/utils/token"
let loadingCount = 0

const service = axios.create({
  baseURL: "", //"https://q4abbz86h7.execute-api.cn-northwest-1.amazonaws.com.cn/dev",
  timeout: 45000,
  withCredentials: true,
  headers: { "Content-Type": "application/json" }
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      if (config.data instanceof FormData) {
        config.data.append("token", token)
      } /*else if (config.data) {
        config.data = { ...config.data, token }
      } else {
        config.data = { token }
      }*/
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data"
    }

    const loading = !(config.loading === false || config.loading === 0)
    config.showLoading = loading

    if (loading) {
      loadingCount++
      const isLoading = store.state.app.isLoading
      if (loadingCount === 1 && !isLoading) store.dispatch("app/showLoading")
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    clearLoading(response.config)

    const res = response.data
    if (res.status !== 0) {
      return handleBusinessError(res)
    }

    return res
  },
  error => {
    clearLoading(error.config)

    if (error.response) {
      return handleHttpError(error.response)
    }
    handleNetworkError(error)
    return Promise.reject(error)
  }
)

const clearLoading = config => {
  if (config?.showLoading) {
    loadingCount--
    if (loadingCount === 0) {
      store.dispatch("app/clearLoading")
    }
  }
}

// TODO
// 错误处理函数
const handleHttpError = response => {
  const msgMap = {
    400: i18n.t("index").msg.RequestError, //"请求错误",
    401: i18n.t("index").msg.LoginExpired, //"登录过期，请重新登录",
    403: i18n.t("index").msg.AccessDenied, // "拒绝访问",
    404: i18n.t("index").msg.ResourceNotExist, //"请求资源不存在",
    500: i18n.t("index").msg.ServerError, // "服务器错误",
    502: i18n.t("index").msg.GatewayError, //"网关错误",
    503: i18n.t("index").msg.ServiceUnavailable //"服务不可用"
  }

  const msg = response.data?.message || msgMap[response.status] || "Network Error"
  // Message({
  //   message: msg,
  //   type: "error",
  //   duration: 2500
  // })

  return Promise.reject(response)
}

const handleBusinessError = res => {
  const errorMap = {
    1001: "参数验证失败",
    1002: "会话过期",
    1003: "操作频繁"
  }
  const msgMap = {
    noUser: i18n.t("index").msg.UserNotExist,
    passwordError: i18n.t("index").msg.WrongPassword,
    noActivate: i18n.t("index").msg.NotActivate,
    failed: i18n.t("index").msg.FailedRetry
  }
  // Message.error(errorMap[res.code] || res.msg || "Backend Error")

  const msg = msgMap[res.msg] || i18n.t("index").msg.FailedRetry || "Backend Error"
  // Message({
  //   message: msg,
  //   type: "error",
  //   duration: 2500
  // })

  return Promise.reject(res)
}

const handleNetworkError = error => {
  if (error.message.includes("timeout")) {
    // Message.error(i18n.t("index").msg.NetworkTimeout || "Network Timeout")
  } else {
    //  Message.error(i18n.t("index").msg.NetworkError || "Network Error")
  }
}

export default service



// WEBPACK FOOTER //
// ./src/utils/service.js